const isColumn = (v: string) => v.match(/\[([^\[\]]+)\]/g);

const convertValue = (v: string, row: any) => (isColumn(v) ? row[v.slice(1, v.length - 1)] : v);

export { isColumn, convertValue };

export {
	getComponentData,
	convertFieldsForMobile,
	handleDataForMobile,
	convertValuesAsString,
	handleRowsForMobile,
	filteringStaticForMobile
} from './mobile';

export { controlColumnVariables } from './column';

export { subscribeMobilEvents, onSearchingChangeStatic } from './mobile/subscribeMobilEvents';

export {
	onGridUpdated,
	onRowRemoved,
	onRowUpdated,
	onSelectionChange,
	onRowInserted,
	onRowInserting,
	onRowUpdating,
	onRowRemoving,
	onRowDoubleClick,
	onBeforeToolbarItemClick,
	onColumnButtonClick,
	compareDeletingRowByCellType
} from './events';

export {
	getDataGridProps,
	getDataGridCommonProps,
	onFilteringChange,
	onPageIndexChange,
	onPageSizeChange,
	onSearchingChange,
	onSortingChange
} from './getDataGridProps';

export { getExtremeGridRows } from './getDataGridRows';

export { setDefaultDataGridProps } from './setDefaultDataGridProps';
